import angular from 'angular';

const decimalValue = angular.module('ttb.directives.decimalValue', [])
    .directive('decimalValue', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                ctrl.$validators.decimalValue = function (modelValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        // consider empty models to be valid
                        return true;
                    }

                    let precision = attrs.precision ? Number(attrs.precision) : 0;

                    if (isNaN(precision)) precision = 0;

                    let allowNegative = attrs.allowNegative !== 'false';

                    let regex = new RegExp('^' + (allowNegative ? '[\\+-]?' : '\\+?') + '(\\d*\\.)?\\d{1,' + precision + '}$');

                    return regex.test(modelValue);
                };
            }
        };
    })
    .name;

export default decimalValue;


// WEBPACK FOOTER //
// ../directives/decimal-value.js